import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { IRoutineTemplate } from '@app/pages/settings/interfaces/routine.interfaces';
import { EntityPriorityComponent } from '../../../../shared/entity-workspace-components/entity-priority/entity-priority.component';
import { EntityCategoryComponent } from '@app/shared/entity-workspace-components/entity-category/entity-category.component';
import { EntityDescriptionComponent } from '@app/shared/entity-workspace-components/entity-description/entity-description.component';
import { EntityScheduleComponent } from '../../../../shared/entity-workspace-components/entity-schedule/entity-schedule.component';
import { EntityCreatedByComponent } from '@app/shared/entity-workspace-components/entity-created-by/entity-created-by.component';

@Component({
	selector: 'routine-information-tab',
	imports: [
		EntityPriorityComponent,
		EntityCategoryComponent,
		EntityDescriptionComponent,
		EntityScheduleComponent,
		EntityCreatedByComponent,
	],
	templateUrl: './routine-information-tab.component.html',
	styleUrl: './routine-information-tab.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoutineInformationTabComponent {
	config = input<IRoutineTemplate>();
	canEditTemplate = input<boolean>(true);
	updateData = output<Partial<IRoutineTemplate>>();

	updateDataFn(data: Partial<IRoutineTemplate>) {
		if (!this.canEditTemplate()) {
			return;
		}
		this.updateData.emit(data);
	}
}
